<div class="card-row">
    <div class="chip" [ngClass]="visual().typeClass">
        <ra-icon [icon]="visual().icon" [varColor]="visual().color" [size]="20" />
    </div>

    <div class="content">
        <div class="title-row">
            <span class="ra-label-m title" [class.bold]="showPin()">{{ notification().title }}</span>
            <span class="ra-label-xs time" [title]="fullDate()">{{ relativeTime() }}</span>
        </div>

        <p class="ra-label-xs message">{{ notification().message }}</p>

        @if (showCompany()) {
            <span class="company">{{ notification().company?.name }}</span>
        }
    </div>

    @if (showPin()) {
        <span class="pin" aria-hidden="true"></span>
    }
</div>
